import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { set_session_expiry_from_response } from '@/utils/auth/session_manager';

function normalize_text(value) {
  return String(value || '').trim();
}

function project_name_candidates(data = {}) {
  return [
    data?.project_name,
    data?.current_project_name,
    data?.selected_project_name,
    data?.project?.project_name,
    data?.project?.name,
    data?.current_project?.project_name,
    data?.current_project?.name,
  ];
}

function project_display_name(data = {}) {
  return normalize_text(project_name_candidates(data).find(Boolean));
}

export default {
  name: 'UserLogin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },
  mounted() {
    const redirect_reason = sessionStorage.getItem('auth_redirect_reason');

    if (redirect_reason) {
      sessionStorage.removeItem('auth_redirect_reason');
      this.show_error_toast(redirect_reason);
    }
  },
  methods: {
    async login_function() {
      if (!this.username || !this.password) {
        this.show_error_toast('Please enter your username and password.');
        return;
      }

      this.verification_running = true;

      try {
        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password
        });

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        sessionStorage.setItem('token', response_data.token);
        sessionStorage.setItem('user_id', response_data.user_id);
        sessionStorage.setItem('current_user_id', response_data.user_id);
        sessionStorage.setItem('user_role', response_data.role_type);
        sessionStorage.setItem('current_role', response_data.role_type);
        sessionStorage.setItem('is_aic_one_login', false);
        sessionStorage.setItem(
          'user_email',
          normalize_text(response_data.email || response_data.user_email || this.username)
        );
        set_session_expiry_from_response(response_data);

        this.$store.dispatch('setCurrentUserId', response_data.user_id);
        this.$store.dispatch('setCurrentLeadId', response_data.lead_id);
        this.$store.dispatch('setCurrentRole', response_data.role_type);
        this.$store.dispatch('setCurrentLeadName', response_data.full_name);
        this.$store.dispatch('setCurrentProjectName', project_display_name(response_data));

        const is_first_time = response_data.first_time_login === true;
        sessionStorage.setItem('first_time_login', is_first_time ? 'true' : 'false');

        if (is_first_time) {
          this.$router.push({
            path: '/first_time_login',
            query: {
              user_id: response_data.user_id,
              token: response_data.token,
            }
          });
          return;
        }

        this.$router.push('/one_time_pin');
      } catch (error) {
        this.show_error_toast(
          error?.response?.data?.message || 'Invalid username or password.'
        );
        return;
      } finally {
        this.verification_running = false;
      }
    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
